import { RARITY_COLORS } from '@shefira/shared';

/**
 * The fire shared by a legendary piece's outline (`rarity-shine.ts`) and the
 * +10 halo (`upgrade-shine.ts`): the rarity's orange from dark to white-hot.
 */
export const BLAZE_RAMP = [0xa34400, 0xff7a1c, RARITY_COLORS.legendary, 0xffe08a, 0xfff6d8] as const;

/** A stable pseudo-random number in [0, 1) for a pixel at a tick. */
export function hash(x: number, y: number, tick: number): number {
  let h =
    Math.imul(x + 3001, 0x27d4eb2d) ^ Math.imul(y + 7919, 0x165667b1) ^ Math.imul(tick, 0x9e3779b1);
  h = Math.imul(h ^ (h >>> 15), 0x85ebca6b);
  return ((h ^ (h >>> 13)) >>> 0) / 4294967296;
}

/** The ramp's shade for a wave in [0, 1]: squared, so the bright part stays a narrow arc. */
export function blazeShade(wave: number): number {
  const top = BLAZE_RAMP.length - 1;
  return BLAZE_RAMP[Math.min(top, Math.floor(wave * wave * (top + 1)))] ?? BLAZE_RAMP[1];
}
